/**
 * @file The do method action
 * @author Tzi Yang Lum
 */
import * as tslib_1 from "tslib";
import { ActionBase } from '../action';
var DoMethodAction = /** @class */ (function (_super) {
    tslib_1.__extends(DoMethodAction, _super);
    /**
     * The do method action
     * @param {string} method
     * @param {DomainService} domainService
     * @param {string} eventsService
     * @param {EventsService} icon
     * @param {string} labelKey
     */
    function DoMethodAction(domainService, eventsService, icon, labelKey) {
        var _this = _super.call(this, icon, labelKey) || this;
        _this.domainService = domainService;
        _this.eventsService = eventsService;
        /**
        * The success labelkey
        */
        _this.successLabelKey = 'APP.SOCIAL.ACTION_SUCCEEDED';
        return _this;
    }
    /**
     * Execute the action
     * @param {ActionConfiguration} actionConfiguration The action configuration
     */
    DoMethodAction.prototype.do = function (input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var method = input.actionConfiguration.method;
                        var item = input.item;
                        if (!method && method === '' || typeof item[method] !== 'function') {
                            reject({ labelKey: 'APP.SOCIAL.ACTION_NOT_FOUND' });
                        }
                        var alertLabel = item[method]();
                        _this.subscriptionPool.add(_this.domainService.saveChanges(function (error) {
                            if (error) {
                                _this.eventsService
                                    .register('action-completed')
                                    .emit(false);
                                reject({ labelKey: 'APP.SOCIAL.ACTION_NOT_FOUND', message: error });
                            }
                        }).subscribe(function (response) {
                            _this.eventsService
                                .register('action-completed')
                                .emit(true);
                            resolve(alertLabel || _this.successLabelKey);
                        }));
                        resolve(_this.successLabelKey);
                    })];
            });
        });
    };
    DoMethodAction.prototype.isDisabled = function (entity, name, backendSettingsService) {
        if (name === 'enable-user') {
            return entity['Status'] === 'ENABLED';
        }
        if (name === 'disable-user') {
            return entity['Status'] === 'DISABLED';
        }
        return _super.prototype.isDisabled.call(this, entity, name, backendSettingsService);
    };
    return DoMethodAction;
}(ActionBase));
export { DoMethodAction };
